<template>

    <list-container :name="name">

        <list-nav>
            <list-nav-header title="Payment Certificates"></list-nav-header>


            <list-nav-scroll>
                <ul class="hidden-desktop mobile-list-view">
                    <li v-for="item in items" class="no-icons">
                        <a :href="item._links.frontend.view" class="info">
                            <span>{{ item.package.data.project }}</span>
                            <span>{{ item.application }}</span>
                            <span>{{ item.package.data.name }}</span>
                            <span>£{{ item.net }}</span>
                        </a>
                    </li>
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                                <span slot="no-more">
                                  End Of Payment Certs
                                </span>
                        </infinite-loading>
                    </li>
                </ul>

                <table class="responsive-table fix-head hidden-mobile">
                    <thead>
                        <tr>
                            <th scope="col">Application</th>
                            <th scope="col">Package</th>
                            <th scope="col">Reference</th>
                            <th scope="col">Date</th>
                            <th scope="col">Gross</th>
                            <th scope="col">MCD</th>
                            <th scope="col">Retention</th>
                            <th scope="col">Net</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items">
                            <td scope="row" data-label="Application"><a :href="item._links.frontend.view">{{ item.application }}</a></td>
                            <td data-label="Package" v-if="item.package"><a :href="item._links.frontend.view">{{ item.package.data.project }}: {{ item.package.data.name }}</a></td>
                            <td data-label="Package" v-else>No package</td>
                            <td data-label="Reference"><a :href="item._links.frontend.view">{{ item.reference }}</a></td>
                            <td data-label="Date">{{ item.date }}</td>
                            <td data-label="Gross">&pound;{{ item.sum }}</td>
                            <td data-label="MCD">&pound;{{ item.mcd }}</td>
                            <td data-label="Retention">&pound;{{ item.retention }}</td>
                            <td data-label="Net">&pound;{{ item.net }}</td>
                        </tr>
                    </tbody>
                </table>
                <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading" :distance="400">
                    <span slot="no-more">
                      End Of Payment Certificates
                    </span>
                </infinite-loading>
            </list-nav-scroll>
        </list-nav>

    </list-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        props:['compact','packageId'],
        data() {
            return {
                name: 'pcs',
                items: [],
                nextPaginationUrl: '',
                search_query: null,
            }
        },
        filters: {

        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            },
            view_all(){
                if(this.compact === true || this.compact == 'true')
                {
                    return false;
                }

                return true;
            }
        },
        methods: {
            getItems() {
                var that = this;
                var url = appUrls.pcs.index;
                var params = {};

                if (this.packageId) {
                    params.package_id = this.packageId;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next'];
                    });
            },
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500)
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('list-view-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>
